import { FC, PropsWithChildren } from 'react';
import { noop } from 'utils/noop';
import { OverlayBodyOverrides, OverlayScreen } from './Overlay.styled';
import { OverlayProps } from './Overlay.types';

export const OVERLAY_TEST_ID = 'overlay';

export const Overlay: FC<PropsWithChildren<OverlayProps>> = ({
  invisible = false,
  isActive = true,
  onOverlayClick = noop,
  preventBodyScroll = false,
  transitionDuration = 200,
  zIndex = 1,
  children,
  ...props
}) => {
  return (
    <>
      <OverlayScreen
        onClick={onOverlayClick}
        isActive={isActive}
        invisible={invisible}
        transitionDuration={transitionDuration}
        data-test={OVERLAY_TEST_ID}
        zIndex={zIndex}
        {...props}
      >
        {children}
      </OverlayScreen>
      {isActive && preventBodyScroll && <OverlayBodyOverrides />}
    </>
  );
};
